import { Chip, StatusChip } from "$components/chip";
import { InvoiceStatus } from "elephant-web/gql";
import type { InvoiceMoneyStatus } from "./invoice-money";

const LOCKED_LABELS: Partial<Record<InvoiceStatus, string>> = {
  [InvoiceStatus.Draft]: "Draft",
  [InvoiceStatus.Void]: "Void",
  [InvoiceStatus.Refunded]: "Refunded",
  [InvoiceStatus.PartiallyRefunded]: "Partially refunded",
};

const MONEY_CHIPS: Record<
  InvoiceMoneyStatus,
  { label: string; color: "success" | "warning" | "primary" }
> = {
  paid: { label: "Paid", color: "success" },
  partial: { label: "Partially paid", color: "warning" },
  unpaid: { label: "Unpaid", color: "primary" },
};

const moneyStatusForInvoice = (status: InvoiceStatus): InvoiceMoneyStatus => {
  if (status === InvoiceStatus.Paid) return "paid";
  return status === InvoiceStatus.PartiallyPaid ? "partial" : "unpaid";
};

/**
 * `moneyStatus` is the status derived from the invoice's transactions; without
 * it the chip falls back to the stored status, which is all a collapsed row has
 * to hand.
 */
export const InvoiceStatusChip: FC<{
  status: InvoiceStatus;
  moneyStatus?: InvoiceMoneyStatus;
}> = ({ status, moneyStatus }) => {
  const lockedLabel = LOCKED_LABELS[status];
  if (lockedLabel) {
    return <StatusChip status="disabled" label={lockedLabel} size="small" />;
  }

  const chip = MONEY_CHIPS[moneyStatus ?? moneyStatusForInvoice(status)];
  return <Chip size="small" color={chip.color} label={chip.label} />;
};
